import { render, staticRenderFns } from "./authGoogle.vue?vue&type=template&id=949a04ae&"
import script from "./authGoogle.vue?vue&type=script&lang=js&"
export * from "./authGoogle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports